import { TimeTrackingTab } from '../const'
import { WeekRange } from '../types'

interface TabConfig {
  startKey: string
  endKey: string
  rangeType: 'week' | 'month'
  defaultsToOwnTeam: boolean
}

const TAB_CONFIG: Record<TimeTrackingTab, TabConfig> = {
  [TimeTrackingTab.MY_TIMES]: {
    startKey: 'start',
    endKey: 'end',
    rangeType: 'week',
    defaultsToOwnTeam: true,
  },
  [TimeTrackingTab.ALL_TIMES]: {
    startKey: 'allStart',
    endKey: 'allEnd',
    rangeType: 'week',
    defaultsToOwnTeam: false,
  },
  [TimeTrackingTab.MY_TEAM]: {
    startKey: 'teamStart',
    endKey: 'teamEnd',
    rangeType: 'month',
    defaultsToOwnTeam: true,
  },
  [TimeTrackingTab.MY_ORDERS]: {
    startKey: 'ordersStart',
    endKey: 'ordersEnd',
    rangeType: 'month',
    defaultsToOwnTeam: true,
  },
}

interface DefaultsContext {
  params: Record<string, unknown>
  tab: TabConfig
  currentUserId: string
  isTeamLeader: boolean
  weekRange: WeekRange
  monthRange: WeekRange
}

type Resolver = (ctx: DefaultsContext) => Record<string, string> | null

const resolveDateRange: Resolver = ({ params, tab, weekRange, monthRange }) => {
  if (params[tab.startKey] && params[tab.endKey]) return null
  const fallback = tab.rangeType === 'month' ? monthRange : weekRange
  return { [tab.startKey]: fallback.startDate, [tab.endKey]: fallback.endDate }
}

const resolveLeader: Resolver = ({
  params,
  tab,
  currentUserId,
  isTeamLeader,
}) => {
  if (!isTeamLeader || !tab.defaultsToOwnTeam) return null
  if (params.leader || params.member) return null
  return { leader: currentUserId }
}

const RESOLVERS: Resolver[] = [resolveDateRange, resolveLeader]

interface ResolveUrlDefaultsArgs {
  params: Record<string, unknown>
  currentTab: TimeTrackingTab
  currentUserId: string
  isTeamLeader: boolean
  weekRange: WeekRange
  monthRange: WeekRange
}

export const resolveUrlDefaults = ({
  currentTab,
  ...rest
}: ResolveUrlDefaultsArgs): Record<string, string> =>
  RESOLVERS.reduce<Record<string, string>>(
    (acc, resolve) => ({
      ...acc,
      ...resolve({ ...rest, tab: TAB_CONFIG[currentTab] }),
    }),
    {},
  )
